import { ref } from "vue";

const visible = ref(false);
// Set when opened from somewhere other than the current route's own TopBar
// Share button (e.g. a project card's menu) — lets ShareModal share a
// specific project without navigating there first.
// anchorRect (optional): the triggering button's getBoundingClientRect(),
// snapshotted at click time — when present, ShareModal opens as a popover
// near that button instead of centered (see TopBar.vue's onShareClick).
const overrideContext = ref(null); // { resourceId, resourceName, anchorRect? } | null

export function useShareModal() {
  function open(context = null) {
    overrideContext.value = context;
    visible.value = true;
  }
  function close() {
    visible.value = false;
    overrideContext.value = null;
  }
  return { visible, overrideContext, open, close };
}
